import { render } from "./SortCategoryModal.vue?vue&type=template&id=bd93a62c&scoped=true"
import script from "./SortCategoryModal.vue?vue&type=script&lang=js"
export * from "./SortCategoryModal.vue?vue&type=script&lang=js"

import "./SortCategoryModal.vue?vue&type=style&index=0&id=bd93a62c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd93a62c"]])

export default __exports__